module.exports = {
  "+1Wujb": "{num} items",
  "+4lD9e": "Name",
  "+L9lak": "Apply Alert Template",
  "+bRanp": "Please fill in the maximum number of notifications",
  "+d7aNN": "Alert Template List",
  "/COTHZ": "The alert module name cannot be empty",
  "/cqdKk": "Download",
  "/l9tS2": "Not Triggered",
  "/sI6h+": "",
  "03eM6t": "200 items/page",
  "0JCY6+": "Deployer",
  "z9+Z7p": "Select All Tagged Devices",
  "0sn8j/": "Please fill in your name",
  "1UXyeT": "Trigger Time",
  "1WymPU": "Select Alert Trigger Value",
  "2+X2n8": "Batch Delete",
  "28oE7E": "No Device Selected",
  "29A4OA": "Company Member",
  "2QzYmY": "Cancel",
  "2rDc7R": "Alert rules cannot be empty",
  "2t0Cct": "Deployment Date",
  "32AbcK": "Select Company",
  "36+mbi": "Processing Status",
  "3HzQUc": "Export JSON",
  "3RVwfq": "Please fill in the comments",
  "3aYG4L":
    "Remove the alert template currently applied to the device and no longer monitor and send alerts",
  "3qVnoZ": "Number of devices ({num})",
  "4/e9qs": "Please fill in the name",
  "4VVrWd":
    "Are you sure to disable ({name}) the alert template? After disabling it, new alert devices will not be able to apply the template.",
  "4vWL+W": "Import Device",
  "4wi+/p": "Template",
  "5SSVAQ": "New Alert Template",
  "5grmob": "Please fill in your email address",
  "5p8cBO": "Account Management",
  "60Ixlm": "Alert Template Name",
  "6ABIlp": "Trigger Status",
  "6mjOF/": "Batch Reset",
  "7G1c4h": "Alert Device List",
  "8PESa6": "Disable",
  "919TK9": "Supported formats: xls, xlsx",
  "9Kfib+": "Unknown error",
  "9UefLp": "Tag",
  B57Wbu: "No Device Selected",
  BC74I9: "Prompt Message",
  BQcLxf: "Move Down",
  BYbqwY: "Drag the file here or click to upload",
  BhkglP: "View Token",
  BwXapw: "Please control the category name within 500 characters",
  CLqPBU: "Edit",
  D3lDHK: "Add Alert Rule",
  D5HOUz: "Select Status",
  E2kRYi: "Batch Enable",
  "EZ+vMa": "Template Annotation",
  EwM8Kj: "Are you sure you want to move out?",
  Ey9rBq: "Are you sure you want to delete it?",
  F2LJDJ: "Are you sure you want to remove?",
  F56ZKt: "Select Members",
  FEb7U2: "Confirm",
  "FaJ/jI": "No file selected for import",
  FbCeo1: "Trigger Value",
  FbsCUK: "Mobile Phone",
  FeJVkL: "Add Additional Recipients",
  "Fr1I/b": "Tag",
  "G+BH4o": "Are you sure to delete the current device ({name})?",
  GKSW97: "Batch Disable",
  GQ5EVQ: "Please check at least one",
  GUMdjP: "Last Execution Status",
  Gk0Mt5:
    "Are you sure to reset ({name}) the alert device? After reset, the alert rules will continue to be monitored.",
  GujK99:
    "If the content of the alert template is updated later, it will also be synchronized to the applied device",
  HN1dNJ: "All Accounts",
  IqkgWZ: "Keyword",
  "Iwt/8W": "Annotation",
  "J0D5h+": "Start Time",
  J9jPRL: "Copy successfully",
  JJl2M9: "Export",
  JeJAmT: "Rename",
  Jh62y5: "All Devices",
  Jp7u8z: "",
  LWSLHa: "Warm Reminder",
  Ls1X2Z: "Processed",
  "LuP+H0": "Description",
  LwhdsE: "Toggle Multiple Selections",
  MnTdIi: "Number of Triggers",
  MvGPdx:
    "Are you sure to enable ({name}) the alert template? After enabling it, new alert devices can apply the template.",
  N4np50: "Maximum number of notifications",
  NTanl8: "Add Alert Template",
  NW8FV4: "Device Command Status",
  OsMncl: "Not turned on",
  "P/eul9": "No",
  P6YSaZ: "Alert History",
  PgNsL5: "Deploying",
  "Py/5UG": "The node being operated no longer exists, please operate again",
  "Q2/NzC": "{num} devices have been selected",
  QHhMxE: "Select a character",
  QV3pnn: "Status",
  "QavrS/": "Rule Name",
  QwHI8Q: "Query Results：",
  R2D5Dv: "Created Time",
  R3TTCW: "Edit Alert Template",
  S57QRB: "Filter by",
  SGDlQ6: "{total} items in total",
  T3CtvK: "Category name cannot be empty",
  TDuPUp: "Triggered",
  TqDOFU: "Please do not send verification codes frequently!",
  U2DqqT: "Search Company",
  UBbWUL: "No Template Selected",
  UFjZVV: "Deployment Status",
  UUtqvk: "Unprocessed",
  UcumBq: "Alert Notification",
  UtE0dS: "Operation",
  "Uu/nFu": "Remove all alert templates applied to this device",
  V0RiZp: "Operation successful",
  VR6zMp: "Are you sure you want to disable it?",
  VRizgn: "Please fill in your mobile phone number",
  ViVQNi: "Role",
  WeKYMe: "Last Order Time",
  Wp6QLH:
    "Do you confirm resetting ({name}) the alert rule? After resetting, the alert rule will continue to be monitored.",
  "WwRq+y": "Please add an alert notification object",
  "X/cNgA": "Delete Reminder",
  XFEq9J: "Template Status",
  XG2wHz: "Deployment successful",
  XMBOec: "Remove Tag",
  XeiAal: "Delete",
  XgmTAk: "Device SN",
  YBAsWB: "Device Command",
  YpXN8m: "Last Trigger Time",
  ZETl7o: "Alert Template",
  ZMUuo8: "Are you sure you want to enable it?",
  ZPSpaL: "Alert Module Name",
  ZUPzqr: "Enabled",
  "Zvt+2g": "Warehouse",
  aBleoN: "Select Alert Template",
  "aN+DgN": "Activation Time",
  aiBGBs: "Delete successfully",
  "arp+TQ": "50 items/page",
  "bE+h3K": "Device Status",
  bOKDVF: "Toggle Radio Selection",
  bqbDVw: "Query",
  cDZ00w: "View",
  drCsUI: "Company",
  e8OyHO: "20 items/page",
  f7Dpbl:
    "Download the template and improve the content according to the template prompts",
  fz2pkM: "This node has been deleted",
  gU4eZD: "Alert Management",
  ggvI6Z: "Select All",
  gomg5W: "Disable Reminder",
  gzHM5l: "Alert Release Date",
  "hDx3/S": "Email",
  hMboy7: "Command Status Details",
  iKomBu: "No classification yet",
  ieTzi7: "Alert Template Details",
  ifGp4v: "2FA",
  iyOrrD: "100 items/page",
  j6IHvr: "View Details",
  jT6zKT: "Number of Devices",
  jdbKm7: "Alert Notification Object",
  jddlWH: "Deployment Failed",
  kCh5Jz: "hint",
  kG2Etz: "Online",
  khyRcw: "Please select Excel file",
  kwOS33: "Enable Reminder",
  l1fZNE: "Cannot uncheck all boxes",
  loTFGc: "Unnamed",
  m0Qdyj: "Verification Failed",
  ma6S6y: "Customized Display",
  "mpeFt+": "Alert Rules",
  nH1F3p: "Are you sure to delete the current alert rule of ({name})?",
  nJCPaY:
    "The user does not have an email address bound and cannot be verified",
  nUSeQB: "No Account Selected",
  nw8orn: "Number of people notified",
  pBPyFt: "Nubis Version",
  "pV2t/S": "Basic Information",
  pcU9bM: "Add Member",
  q6qKtH: "Query Condition：",
  qUKj7E: "Copy",
  "r0/TUu": "OK",
  "r2dEd/": "Reset",
  s9U9qn: "Set Alert",
  sOIerB: "Not activated",
  sZSyGZ: "Enable",
  srEpKw: "Uploading",
  srpWCM: "Check the fields that need to be displayed and drag them to sort",
  t2iHNJ: "Update",
  "tCh+iz": "Alert Release Time",
  tLW3W3: "Mobile Phone Number",
  tokMPz: "Exception Object",
  "uoZwj+": "Creator",
  v04auv: "End Time",
  w8L9Kj: "Configure Alert Rules",
  wOHHSJ: "Move Up",
  wQAiLI: "Reset Reminder",
  xISm1t: "activate",
  xUjLTE: "Search",
  y9NWzQ: "Alert Device List",
  yGWx2z: "Parameter Error",
  yOMNOj: "Yes",
  yReEcE: "Select Tag",
  yXsHgv: "10 items/page",
  yb3AuG: "Offline",
  ybGQQ3: "No relevant results",
  "yiO/gL": "Alert Template List",
  yxPDHk: "Release Status",
  zH7h1q: "Alert History",
  "96Mzoq": "Completed",
  ByhhM1: "Condition",
  PcCooF: "Alert Trigger Value",
  RUMaeu: "Please fill in the alert rules completely",
  h7w4pz: "No Data",
  nMMNa6: "We will notify you via email, SMS or system.",
  "nOE0/j": "Search for companies and members",
  q6WPYA:
    "The selected device contains {num} Nubis Free versions, and merchant sending commands will not be possible.",
  "+CP3nr": "Select a Task",
  "+gbx50": "Alert Condition",
  "+wet4N": "Verification Code Error",
  "/BzHXM": "Select The Creator",
  "/SqqyP": "Enter the device serial number",
  "0YYUNG": "{num} tags have been selected",
  "1M03Dq": "Schedule Template",
  "1SslIM": "Close Application",
  "1gjtU2": "Last Execution Time",
  "1sj5Sj": "Remove all schedule templates applied to this device",
  "2MYr1m": "Login",
  "2l+gFk":
    "Are you sure to enable ({name}) the schedule template? After enabling it, the device can reference the template.",
  "2opnVU": "During Execution",
  "2r/XUW": "Remove all schedule templates applied by this tag",
  "3xlnbE": "Command Time",
  "47GdDb": "Disabled",
  "5ytYaf": "New Schedule Template",
  "65DvZ1": "Input upper limit: 4",
  "6x6nu5": "Actual Execution Time",
  "8zN+hZ": "Execute Application",
  "9UZxwP": "Please enter the verification code",
  "9kkcTB": "Delete Schedule Template",
  "9ljNkr": "Resend",
  "A/eXwT": "Remove all alert templates applied to this label",
  AyWMlZ: "Add Scheduled Task",
  BiPxfI: "Add Schedule Template",
  C6cGK1: "Schedule template name cannot be empty",
  EGvInA: "Device Alert List",
  Ft60hS: "Nubis device",
  Gwj7xc: "Restore Default",
  H15ECl: "Input Application",
  "J3BW/8": "Please enter the verification code you received via email",
  KW8qOm: "Select Template",
  LADN1a: "Schedule Execution Status",
  Lfia0v: "Set Schedule",
  NDmD8V: "Are you sure to delete the schedule template ({name})?",
  OVecAI: "Success",
  OwtOn5: "Total Status",
  PTc6Gt: "Enable Schedule",
  PaMvre: "Alert Rule List",
  PnYplH: "Device",
  RNaGVr: "Task Failure List",
  RWBRyt: "Device distribution map is under construction",
  "RuFFf/":
    "Are you sure to disable ({name}) the schedule template? After disabling, the device cannot reference the template.",
  SPyEF8: "Select Mode",
  SwMBFl: "Apply Schedule Template",
  TDSTTj: "Select Schedule Template",
  UMU42c: "Select Device",
  Unvxiq: "Switch Account",
  WxPZOH: "Execute {num} times",
  WypzMq: "Scheduled Tasks",
  X2m4ec: "Disable Schedule Template",
  "YIgP+p": "Device Schedule List",
  LNGTru: "Device Schedule Fail List",
  YwEzx2: "Check the fields that need to be displayed",
  Z2B362: "Continuous",
  ZBDct6: "Failed: {num}",
  ZHAjhZ: "Input upper limit: 30",
  Zr9Dss: "Failed",
  azDNha: "Sent successfully",
  b5l2vN: "Save",
  b6y8Ai: "Are you sure to disable ({name}) the schedule?",
  bYIKFB: "In Progress: {num}",
  "e/6XZC": "Didn't receive the verification code?",
  eAgY2G: "Expand Subsidiaries",
  fl7J8Y: "Message",
  "gH+Az7": "Disable Schedule",
  gi4oTZ: "Schedule Template List",
  gplM71: "Daily",
  "hAd+eG": "Device Schedule Calendar",
  "hD7/Lu": "Display",
  hYN7oM: "Hide",
  hfn1Ux: "Success/Total",
  hkJXyi: "Configure scheduled tasks",
  "hkR3E+": "View Mode",
  hwlmeB: "Target Type",
  iN7Lps: "Loop Mode",
  pGioLb: "Device SN",
  "wnPTP+": "Input Device SN",
  iscUWH: "Complete: {num}",
  "j/YGZ0": "Map",
  wDqNy1: "Example",
  P76mDe: "Synchronous File Management",
  j6Hm96: "Scheduled Execution",
  jNxbTC: "Verification code cannot be empty",
  js3tZs: "Schedule Template Name",
  k9dozc: "Execution Time",
  kUagYW: "Schedule Execution History",
  l7IiCY: "Schedule Status",
  "lzP/we": "ORA Download",
  "5EJNIu": "Search For Devices Across Companies",
  m1h20o:
    "If the content of the subsequent schedule template is updated, it will also be synchronized to the applied device",
  "mC2//O": "View schedule calendar",
  mFIXSq: "Device SN",
  mISQTh: "Details",
  nGubXb: "Schedule Template Details",
  nqPJwo: "For Tags",
  oCogiy: "Command",
  oY0m24: "User",
  oirnwv: "Enable Schedule Template",
  ojz0Ke: "View More >",
  oru5FY: "Edit Schedule Template",
  "p+zOzc": "Result",
  peNVzr: "Every {num} weeks",
  pfGGi0:
    "Remove the schedule template currently applied to the device and no longer execute it",
  pielKO: "Boot Device",
  pkYJKs: "Execution Status",
  qhC4wy: "Search Device",
  rUHCoM: "Device Schedule",
  sb1vdX: "In Progress",
  u3dVQz: "Weekly",
  "urr92/": "Select the deployer",
  vovKL8: "Application path cannot be empty",
  "wrU/Kc": "Every {num} days",
  ygAHaf: "Sending Time",
  zvaxmN: "Schedule Management",
  "2ffDGT":
    "Are you sure to close the scheduled task? The device will not execute the schedule template after closing.",
  "D//rZg": "Are you sure to delete the application of the schedule template?",
  E1GPl7: "Owner",
  EwTMGn: "Are you sure to enable ({name}) the schedule?",
  GpzsBd: "Open Scheduled Tasks",
  IM8kXz: "Are you sure to delete the application of ({name})?",
  KXqGQe: "Batch Activation",
  NGe0Cs: "Delete Schedule Execution Records",
  SkK50H: "Please add a scheduled task",
  Trt6ju:
    "Are you sure to start the scheduled task? After starting, the device needs to execute the scheduled task.",
  UiVtQS: "Batch Close",
  "Z56D+X": "Close Scheduled Tasks",
  aKxrop: "Delete the application of schedule template",
  miANEg:
    "Are you sure to close ({name}) the scheduled task? The device will not execute the scheduled task after closing.",
  ngLF8L: "Are you sure to delete the schedule execution record of ({name})?",
  nqPOJc:
    "Are you sure to open ({name}) the scheduled task? After opening, the device needs to execute the scheduled task.",
  oV0gpL: "Scheduled Release Date",
  xtHJEE: "No Records Selected",
  yifWnc: "Are you sure to delete the schedule execution record?",
  "+/R6RX": "Task Status",
  "35v5wD": "Are you sure to reset the alert history?",
  "3QXG/d": "Ora Version",
  "5jpkHg": "Online Status",
  G4XFn6: "Hardware Model",
  Ko5CPO: "Are you sure to reset the alert history?",
  ajVpLe: "Are you sure you want to delete this alert history?",
  dEXfrL: "Device Health Status Interval",
  eCCa0L: "Task Type",
  fr4nkj: "Are you sure you want to delete the alert history?",
  nzsNwZ: "Device Health Status",
  qDba8m: "Offline Device Status",
  rDRAr0: "Operating System Version",
  YeF1dY: "Time Zone",
  BC52ne: "Ignored",
  SbZhau: "The boot task needs to specify a boot device",
  "lsLYU/": "The maximum number of notifications cannot exceed 10",
  "NM/lRq": "Cancel Upload",
  "3qF993": "You cannot transfer devices that are not in your current company.",
  "6+iYA0": "No",
  yc6ZUL: "Ora Last Updated Status",
  UA7mv6: "Ora Last Updated Time",
  "fOwU1/": "Belong",
  jNiwk6: "Are you sure to delete the alarm device ({name})?",
  "lLa/D3": "Apply Type",
  "wk1c/l": "According to the device grayscale update time period (local time)",
  "5+oaTO": "Image Last Updated Status",
  "6pDRb2": "Please enter a valid password",
  ANeFu6: "Verify Password",
  GnzEo7: "Image Last Updated Time",
  s7NSze: "Please enter your account password before confirming the operation",
  "9RNrDU": "Whether it is a proxy device",
  "+TzicH": "Merchant",
  "/CxA3j": "Add Sub-merchant",
  "4c3uw8": "Remove Merchant",
  "5Hy0Qx": "Cannot be transferred to the same merchant",
  BBpRbn: "Remove all alarm templates applied by this merchant",
  DADacD: "Remove all schedule templates applied by this merchant",
  G9WbnV: "For Merchants",
  S1QSWC: "Import Sub-merchant",
  TYAJpp: "{num} merchants have been selected",
  Ve9Ksw: "Transfer Merchant",
  Wzv7kF: "Please select a merchant",
  h7Yvwt: "Select All Devices",
  jAAXdQ: "Equipment Merchant",
  i5Nyva: "Unread",
  ich0wH: "Device SN",
  wpKIvP: "Read",
  "kr+7Iy": "Search for merchants",
  tFr3tb:
    "Are you sure to delete the alarm template ({name})? After deletion, the application of this template by the device, merchant and label will be canceled simultaneously.",
  uuRzdk: "Attributed to the merchant",
  vD5wnY:
    "Checking the merchant to belong to means that you have the permission of the merchant",
  zyMKgy: "Select Merchant",
  RndUeh: "Estimated Execution Time",
  gcHeN9:
    "Please fill in the OS application name. For example: Windows:chrome or Android:com.android.chrome",
  EM8lAi: "According to the Device Updateable Time Period (Local Time)",
  "4Regzm": "Merchant List",
  "1PtjRr": "Device Name",
  BqUpjt: "Please fill in the package name, such as com.android.chrome",
  NrEurQ: "Upload Mbps",
  Nrx60r: "Download Mbps",
  Vd3wZV: "Overall",
  WdyIyo: "Operation time",
  "XLdI1+": "Wi-Fi Strength",
  cawvIS: "Last Updated Time",
  "oFt+cN": "Network speed test",
  tWcCoB: "Speed test date",
  xrQzKh: "Please fill In the application name, such as chrome",
  zok1hp: "C Drive",
  i5MLJc: "Last Updated: {lastUpdate}",
  bMdSkq: "Network speed test record",
  "devicesList@1": "Select All Tagged Devices",
  "devicesList@2": "Select All Devices",
  "gyh+d1": "Cable Network",
  "p/3Nn5": "Cellular Network",
  "i6kDf/":
    "The selected device contains {num} Nubis Free versions, and the device command cannot be performed.",
  o8tJYm: "Device command",
  "+74JfZ": "Example: Device_000001_Gaoqiao Merchant_Android",
  "+CLSks": "2. The device system type to which this naming rule applies",
  "+GQdfc": "Update Token",
  "+m8vFq": "Naming rule details",
  "0KH9Qi": "Device OS",
  "0Z908D": "Only one version can be selected for the same application",
  "0bBO2n": "Version",
  "0iTEVO": "View Token",
  "12LEcf": "Are you sure to disable ({name}) this naming rule?",
  "2/LdaO": "Profile Info",
  "2V19bd": "Profile Detail",
  "2jlHQB": "2. Company preset naming rules",
  "3ZtPM3":
    "If the merchant does not set a naming rule, the company's naming rules will be applied when active a new device. If you do not want to apply it, you can disable the following rules",
  "3qgucc": "Manually set time zone",
  "5FboZ/": "Type",
  "5ZgUEM": "Edit Profile Template",
  "5d3yZi": "Effective Time",
  "5noX9X": "Profile Name",
  "6Ty5/G": "Publish Successfully",
  "7NmXNy": "Current Program Information",
  "7PkBL6": "Enable Silent Update",
  "7ip592": "1. Naming Rule Name",
  "88CuCZ":
    "3. Establish a naming rule for devices registered in this merchant (automatically fill in device name)",
  "8WYGi+": "Are you sure you want to copy?",
  "8huAxo": "Add",
  "8pB1C7": "Add An Application",
  "8u3CYe": "Naming Rule Name",
  "8zQ4So": "Package ID:",
  "96c3gX": "Type",
  "9iKk2b": "Starting Number",
  AFZDo7: "Profile History",
  B0WqD0: "1. Device update time period (local time)",
  "CM76+/":
    "Are you sure to enable ({name}) this template? After enabling, the device can reference this template",
  CPTAAj: "Natural Number Increment",
  CqlH6G: "Merchant List",
  "D/Yid+": "Enable",
  D2KnIQ: "Successfully associated with the merchant",
  DpnauN: "Time",
  Fi4xFb: "Successfully uploaded Android application",
  G9APSK: "Edit Naming Rule",
  GRfLaO: "Application Name",
  HDYjnT:
    "The currently selected application version is lower than the existing application, which may cause the application installation to fail. Please confirm whether the application is selected correctly. If you need to install an application with a lower version, you can check to delete the original program before installing it. ",
  HOHQFs: "The naming rule name cannot be empty",
  "HdxQ2/": "Merchant-associated Profiles and Device Naming Rules",
  "I/k8FH": "Publish",
  IyhhzI: "Create a Template",
  Kj5TRg: "Number of devices to be installed",
  "L4w/Vo": "Latest Version",
  MI3yI1: "Uploading {percentCompleted}%",
  MRe8Q9: "Version Number:",
  OCp4OD: "View Profile",
  PDFXBi: "Publish Immediately",
  PkLYZS: "Device Naming Rules",
  PlNIQ9: "System Settings",
  "Q+0CDu": "Add a New Naming Rule",
  Q5vbU5: "Package ID Inconsistent",
  QpOtgZ: "Merchant",
  R9TpN6: "Estimated Installation Time",
  RY4VVr: "Uploader",
  RyXQqJ: "Upload Time",
  UfxykZ: "Reason",
  Unr58u: "Update Time",
  Uzdb6l: "Device Type:",
  VqEr9u: "Number of Merchant to Be Applied",
  WfS4rv: "Operator:",
  XnimdQ: "Windows",
  Ym4SPE: "Select release time (device execution time)",
  ZWN1C0: "Are you sure to enable ({name}) this naming rule?",
  ZdO12B: "Apply To Merchant",
  ZtZ7Yw: "Application Name",
  aHlr3k: "Remove",
  akvGrq: "Naming Rule Content",
  aqQg0p: "Region",
  batMBC: "Are you sure to delete ({name}) this template? ",
  bsjenW: "Enable Naming Rules",
  cX08hK: "No data selected",
  cijnrq: "Installed devices",
  d8xSfX: "Version Code",
  dGBGbt: "All",
  dRYBRc: "Version Number: {version}",
  eUNh5K: "Device to be installed",
  "ecTX+c": "Application Name Required",
  eeCxuz: "OS",
  epaa3H: "Add Naming Rule",
  evJP5c: "Naming Rule Content",
  fX0dsH: "Version:",
  "fje/m/": "Profile Name:",
  fq3WGG: "Profile Management",
  gQ7kPU: "Android",
  gnNjS5: "Personal Device Name",
  gyHdsW: "Profile Template List",
  hDmGQl: "Whether to verify the version code",
  hqGPDw: "Enable 24-hour format",
  hxy4wV: "Parsing",
  i5JzAA: "Status:",
  ie9Iom: "View Profile template",
  ifAmoA: "Profile Template List",
  imhWD8: "Upload Settings",
  iroVTo: "Company Settings",
  j2kqd8: "Delete Naming Rules",
  j3QWSE:
    "The starting number of natural number increment can only be a positive integer",
  jKzbw6: "Change Settings",
  "jN5tO+": "Version Code: {versionCode}",
  "jhfb/7": "Save Successfully",
  k7dy8j: "Associated Profile",
  kH9MHe: "Disable Naming Rules",
  kkLQie: "Apply To Merchant",
  "ksb/lB": "Delete the Original Application",
  l0mW6t: "Latest Update Time",
  mRHwkp:
    "Are you sure to disable ({name}) this template? After disabling, the device cannot reference this template",
  "mYa6W/": "Custom Text",
  "mml+gT": "Select Application",
  mn0ceu: "There are duplicate configuration rules, please adjust",
  n1yIyi: "Installation Time",
  nDwIwd: "Published",
  nLERtc: "Update Android Application",
  o9bMHL: "Size",
  oC6GBl: "Android Application",
  ovdKZi: "Number of devices that cannot be installed",
  qS0aFJ: "Application Management",
  qUiH5y: "Configuration rules cannot be empty",
  qjtl3b: "Enable System Update",
  "qqwM/t": "Profile",
  rdEPl7: "Unable to install device",
  rsAvN6: "Application Name:",
  rw3uGa: "Create a New Profile",
  "s+aIlP": "Search for Merchant",
  saeFbf: "File",
  t8R6VW: "Package ID: {package}",
  twpxdo: "Upload Android Application",
  "u/NB+Y": "Package ID",
  vDCwZ9: "Upload File",
  vLW90z: "Are you sure to delete ({name}) this naming rule?",
  vr5TVT: "Please Enter",
  wiSRo9: "Number of installed devices",
  "xE1H+X": "Settings",
  xdjVt1: "Template name is not filled in",
  xlNcvg: "Last Updated:",
  xwYDb8: "Version Code:",
  ydktLD: "Separator",
  zeMk2K: "Draft",
  zrIs7T: "Last Updated",
  "a++4i0": "The release time must be within 24 hours",
  "3JwoQQ": "Upload failed. The application cannot parse.",
  "9Fvzl9": "Batch Publish",
  OiP4rW:
    "There is a profile associated with the merchant. Please check.",
  b95U3r: "Profile Template List",
  nJetAr: "Unsupported Format.",
  lPA1qT: "This configuration is only for a specific device",
  oXfYag: "The version code already exists, please upload again",
  "k+a7BC": "Execute Silent Update Time",
  "/k2Fs5": "Naming Rule Content",
  e2ys3T: "Profile Information",
  yy7EDI: "Upload",
  "+cCXuw": "Select Image From File",
  "0cZQXI": "Add By Package Id",
  "0xm1Zu": "Lock Key Combination",
  "33bmiC": "Parent directory does not exist",
  "4UcMA+": "Add Wi-Fi",
  "4ia8sI": "Function Control",
  "4o167y": "Custom text length cannot exceed 30",
  "66awCH": "Refresh",
  "C+cw77": "Wallpaper Configuration",
  E6G3sr: "Kiosk Mode",
  "FQK+2G": "File Synchronization",
  FWlWJR: "View Merchant Information",
  HI1PTY: "Enter Folder Path",
  HNavdr: "Company Name",
  JPIKnb: "Home Screen",
  MufYuw: "Lock Screen",
  NPjnPZ: "Brightness",
  "Pdx/YD": "Password",
  Pg5mqb: "Horizontal Mode",
  QSjBm5: "File Does Not Exist",
  UH1kCc: "Add",
  UduVZX: "Select File",
  Usn1oq: "Portrait Mode",
  "Ymq1/H": "Device Folder Name",
  YzG9Iw: "Blacklist",
  ZK1d6f: "SSID",
  bGGvOS: "Select Picture",
  c8uKl6: "Wi-Fi",
  dZlNkV: "Add Configuration",
  dmEBpU: "File Synchronization Configuration",
  foT1aq: "Current Upload Progress:",
  g5Pknn: "File size exceeds limit",
  gltp3e: "Turn off Windows notification",
  gweUAO: "Lock USB interface",
  nxeBGd: "Example:",
  o8HwKf: "File Name",
  rULuF3: "Whether to allow only the following network connections",
  tIm58E: "Stop",
  tR69qg: "Windows Display Language",
  tnYpSo: "Detection request sent successfully",
  xNeD5U: "Cancelled",
  xiwfUp: "Volume",
  znna6r: "Merchant Information",
  "+UT6Us": "Zimbabwe",
  "+cSl6d": "Netherlands",
  "+vx0UI": "Solomon Islands",
  "+vz4Gy": "Sierra Leone",
  "/1g/gd": "Kiribati",
  "/EzG+0": "Montserrat",
  "/ZaEbq": "Haiti",
  "07BMT/": "Algeria",
  "0E6+/f": "Guam",
  "14axoc": "Falkland Islands",
  "1BFTBO": "Cuba",
  "1GLoiG": "Georgia",
  "1Z3cpQ": "Ivory Coast",
  "1qc1Bb": "Latvia",
  "217kis": "Rwanda",
  "2c/STs": "Moldova",
  "3B2kCX": "Faroe Islands",
  "3Nlsp9": "Slovakia",
  "3a17nf": "Cook Islands",
  "41lx/9": "Afghanistan",
  "4KMP9f": "Congo",
  "4obEtL": "Togo",
  "5w+tOJ": "Albania",
  "62Z8c1": "Palau",
  "6JR/Y7": "Ireland",
  "6LZPqX": "Samoa",
  "6Mnz8p": "Mauritania",
  "6NPwCy": "Syria",
  "6f8kym": "Iraq",
  "6qdPnx": "Tunisia",
  "7KZ6vz": "Venezuela",
  "7hGupC": "Lithuania",
  "7hNQVL": "Philippines",
  "7p85Tc": "Curaçao",
  "8m5tda": "Egypt",
  "8y7qAE": "Central African Republic",
  "98qFTO": "Jersey",
  "99fbLn": "Uruguay",
  "9T1JPo": "Malta",
  AD5RPE: "Equatorial Guinea",
  AKnToQ: "Chad",
  "AO/9GT": "Finland",
  AYs4yh: "Madagascar",
  Ai6HyC: "Uganda",
  AksTq6: "Antigua and Barbuda",
  ArbweL: "Jordan",
  AzRGCX: "Germany",
  "B/oRh5": "Federated States of Micronesia",
  BcJbbP: "Qatar",
  Bm5GdP: "Taiwan",
  MRbe2A: "Taiwan",
  BwMY6I: "Western Sahara",
  BxT2qw: "Tokelau",
  C0YR5J: "Turkmenistan",
  C2pikc: "South Sudan",
  C7RUR5: "Nauru",
  CKu8W1: "Niue",
  CYSGlA: "Estonia",
  "D/Hl19": "Martinique",
  DPthJ5: "Luxembourg",
  Dxf50E: "Comoros",
  EMaGPN: "Somalia",
  "Eihfz+": "Pakistan",
  Eul4yJ: "Italy",
  F0BTvX: "Réunion",
  FsQ2Ph: "Northern Mariana Islands",
  FzXhJn: "Vatican City",
  GRDGdf: "New Caledonia",
  "HF/NiY": "Armenia",
  HN9EHr: "South Korea",
  HTqMY5: "Romania",
  HZs8KL: "Burkina Faso",
  I2RkrK: "Cambodia",
  I7Erl3: "Morocco",
  IGBRed: "Azerbaijan",
  IPfyBg: "Iran",
  IbG9YJ: "Norfolk Island",
  "IrME/4": "Macau",
  XeQT0P: "Macau",
  J1oSvz: "U.S. Virgin Islands",
  JIPBj1: "Jamaica",
  JIWrkV: "Canada",
  JJhl02: "Democratic Republic of the Congo",
  JOJTuh: "Costa Rica",
  JddSbX: "Dominica",
  L7PjzJ: "Christmas Island",
  LShUE0: "Bhutan",
  "Le+IiI": "North Macedonia",
  LeMbDw: "Zambia",
  LfkgD6: "Australia",
  Lszars: "United States",
  M16xFB: "Brunei",
  MMzrYK: "Liechtenstein",
  MTVChl: "Tonga",
  MXueJK: "Andorra",
  MYneOz: "Djibouti",
  MZwu6r: "Heard Island and McDonald Islands",
  MbV1M9: "Malaysia",
  MkBrsn: "Paraguay",
  MwNlM3: "Burundi",
  MyB1Vf: "Saudi Arabia",
  NcwUGt: "Israel",
  OZFYbQ: "Vanuatu",
  OZyB9b: "Bosnia and Herzegovina",
  Oc4oig: "Bolivia",
  OhEAqA: "Greece",
  Oql6Jb: "Portugal",
  PB00mS: "Wallis and Futuna",
  PBGuz3: "Poland",
  PIBLYF: "Hong Kong",
  "1ObLsW": "Hong Kong",
  PIHPBR: "Saint Martin (French part)",
  PjOc8o: "Belarus",
  "Q+FGAs": "Iceland",
  "Q5QY0+": "Cayman Islands",
  Q5U8nY: "American Samoa",
  QA9U89: "British Indian Ocean Territory",
  QRUdeg: "Mexico",
  QxRaqi: "Denmark",
  RfQSLo: "North Korea",
  RlB4rB: "South Georgia and the South Sandwich Islands",
  RsWzOr: "Hungary",
  RzKiE0: "Puerto Rico",
  SEJjjI: "Antarctica",
  SLmrMX: "Bulgaria",
  T6qzNm: "Laos",
  Tb6AtC: "United Arab Emirates",
  To4yI6: "Gambia",
  TqXGpl: "Belize",
  UQHsPm: "Cape Verde",
  UZmEHG: "Mongolia",
  Ulf4Sq: "India",
  VCRq6v: "Pitcairn Islands",
  VIFtwp: "Cameroon",
  VTEHKS: "Guinea-Bissau",
  VWg1hF: "Svalbard and Jan Mayen",
  VhGXkw: "Åland Islands",
  W2fcGi: "Suriname",
  W9gKgU: "Seychelles",
  WAl9tj: "East Timor",
  "WH+mo5": "Uzbekistan",
  WJAfY4: "Tuvalu",
  WobBPP: "Liberia",
  XfoqmV: "El Salvador",
  XoOuKT: "Kazakhstan",
  YINkHp: "Serbia",
  YMjT8q: "Singapore",
  "Z+fptr": "Colombia",
  ZHe4St: "Indonesia",
  ZRhaI4: "Barbados",
  ZgLO7j: "Lebanon",
  a9nZYf: "Bouvet Island",
  aNVBIV: "France",
  afgUkt: "Trinidad and Tobago",
  ahaefV: "China",
  b8Yur0: "Benin",
  bCl9eg: "Vietnam",
  bKHwtk: "Bangladesh",
  bQkGVT: "Russian Federation",
  "cio5m/": "New Zealand",
  "d+SgS7": "Nicaragua",
  d97FOT: "Papua New Guinea",
  dUeWgE: "Fiji",
  dXFo2O: "Norway",
  dcfcTW: "Saint Pierre and Miquelon",
  dyBAW0: "Senegal",
  eNa9WG: "Saint Helena",
  eX9WT0: "San Marino",
  eiecNW: "Lesotho",
  eu7j6G: "Montenegro",
  f6i4Ch: "Dominican Republic",
  fSGNZz: "Belgium",
  fe4fox: "Sudan",
  fp4MWN: "Japan",
  g44w8D: "United Kingdom",
  gIZauu: "Guatemala",
  gb8v87: "Turkey",
  h70zPD: "Spain",
  hB6jsF: "Cyprus",
  hBpMeF: "Marshall Islands",
  hC0etv: "Chile",
  hLeEYi: "Saint Vincent and the Grenadines",
  hrmyDn: "Tanzania",
  htLGF6: "Bonaire",
  htNRZG: "Monaco",
  hy4yn7: "Kyrgyzstan",
  iJsE6u: "Mali",
  iVyVIA: "Guernsey",
  iYdC7o: "Nepal",
  icfTwL: "Sri Lanka",
  icoYQF: "French Southern Territories",
  ipoOkJ: "Niger",
  j2GbDK: "Sao Tome and Principe",
  "j83TV+": "Isle of Man",
  jHmcI7: "Guinea",
  jKdq05: "Aruba",
  "jZLo+u": "Yemen",
  kCwSgm: "Sweden",
  lAVHXj: "Gabon",
  lc0eVA: "Saint Barthelemy",
  ljBSDy: "Bahrain",
  mIgnTu: "Bermuda",
  mdbt1h: "Grenada",
  n1eYYR: "Croatia",
  n6sdJi: "Nigeria",
  nU0AoJ: "Mauritius",
  nbVGOe: "Guyana",
  ncprFv: "Palestine",
  nfMTZ9: "Libya",
  "oC/YmL": "Angola",
  oJA0AV: "Ukraine",
  ofe1Jv: "Slovenia",
  ox0SUk: "Eritrea",
  pG9dnN: "French Guiana",
  pGsPfz: "Tajikistan",
  "prG89+": "Sint Maarten",
  "qKL/I7": "Ecuador",
  qhRoDt: "Czech Republic",
  r0r576: "Austria",
  riK5Od: "Mayotte",
  "s/ZbGB": "Gibraltar",
  sVaevR: "French Polynesia",
  sgg3ZA: "Kenya",
  srKhxN: "Bahamas",
  ssKHGM: "Greenland",
  swmjZg: "Thailand",
  "tUisY+": "Ghana",
  u3ws3s: "South Africa",
  u9cEKj: "Saint Kitts and Nevis",
  uPO36O: "Myanmar",
  uY8iM9: "Mozambique",
  ufZlit: "Panama",
  ufyzs9: "Saint Lucia",
  v8IwQb: "Argentina",
  vPS1uD: "Peru",
  vTEjni: "Malawi",
  vcSBZu: "Brazil",
  vixhhG: "Maldives",
  "wL/u2o": "Turks and Caicos Islands",
  "wYCJ++": "Eswatini",
  "we/YPm": "Oman",
  xFrFSm: "Namibia",
  xV0lln: "British Virgin Islands",
  xepQSL: "Cocos (Keeling) Islands",
  xk4ByO: "Guadeloupe",
  xwICWz: "Switzerland",
  yC4n0v: "Kuwait",
  yKWAek: "Anguilla",
  yLlbwi: "Botswana",
  zhs13i: "Honduras",
  zw39MM: "Ethiopia",
  "+31PFz": "Asia/Urumqi",
  "+6yBji": "Asia/Bangkok",
  "+CgfU2": "Pacific/Efate",
  "+POdLR": "Europe/Volgograd",
  "+VqRkg": "America/Kentucky/Monticello",
  "/+Dhy+": "America/Sao_Paulo",
  "/D9zXZ": "Atlantic/Reykjavik",
  "/UGQnF": "America/Nome",
  "0DYv/B": "Africa/Nairobi",
  "0HnaGc": "Pacific/Kwajalein",
  "0R8CQs": "Europe/Budapest",
  "0xV9JO": "America/Argentina/La_Rioja",
  "1H4FmE": "Europe/Uzhgorod",
  "1mv3LM": "Asia/Chita",
  "1pl9Su": "Africa/Tripoli",
  "1sEPCz": "Asia/Tokyo",
  "1ua619": "Europe/Prague",
  "23aBJh": "America/Denver",
  "2DXZtH": "Europe/Copenhagen",
  "2OWj6s": "Asia/Beirut",
  "2WXSh8": "Asia/Karachi",
  "2qYhi8": "Asia/Hong_Kong",
  "2s/Mlc": "Asia/Kamchatka",
  "2zQAXL": "Europe/Chisinau",
  "327IN3": "America/Yakutat",
  "339CIL": "America/Belize",
  "3Lz3cq": "Pacific/Enderbury",
  "40b51E": "America/Miquelon",
  "4AZ4gQ": "America/Argentina/Salta",
  "4D94K+": "Antarctica/Casey",
  "4NXksL": "Europe/Lisbon",
  "4XF+Io": "America/Tegucigalpa",
  "4l3qM7": "Pacific/Noumea",
  "4neOsl": "America/Danmarkshavn",
  "4wb1r/": "Europe/Luxembourg",
  "5M8Wkq": "America/Argentina/Jujuy",
  "5oeyFi": "America/Argentina/Rio_Gallegos",
  "5xwaJJ": "Pacific/Funafuti",
  "6/dk2l": "Europe/Simferopol",
  "6Rz5js": "Africa/El_Aaiun",
  "6XgRmz": "Asia/Hovd",
  "6d5tvh": "America/Boa_Vista",
  "6wYqzG": "Pacific/Wake",
  "71fHGN": "America/Guyana",
  "7Q7WxK": "America/Guatemala",
  "7WBtG1": "Pacific/Majuro",
  "7euHXg": "Pacific/Bougainville",
  "7jiQ+M": "Asia/Taipei",
  "82GEmf": "Pacific/Nauru",
  "8DjTJi": "Pacific/Fakaofo",
  "9Fhwtp": "Africa/Monrovia",
  "9TfEAv": "Asia/Dhaka",
  "9UC6g0": "Asia/Macau",
  "9xN38t": "Asia/Riyadh",
  A1qgI0: "America/Campo_Grande",
  A8Tpo2: "Africa/Cairo",
  ADtcg9: "America/Indiana/Petersburg",
  AQnn4z: "Asia/Qatar",
  AX2M6K: "Africa/Casablanca",
  ApEhaf: "Antarctica/Vostok",
  "BsRS+L": "Africa/Lagos",
  "CIpc+3": "Asia/Rangoon",
  CJgAlM: "America/Argentina/Buenos_Aires",
  CMi686: "Europe/Samara",
  CRI2Ve: "Pacific/Chatham",
  CezJKN: "America/Santiago",
  "Cs/zIo": "Pacific/Marquesas",
  CvKLCn: "Pacific/Tongatapu",
  CwyqPj: "Africa/Accra",
  D1tmTQ: "America/North_Dakota/Center",
  D55vg4: "Africa/Tunis",
  DAlYN5: "Europe/Istanbul",
  DCrzIX: "Europe/Andorra",
  DDqHds: "Africa/Khartoum",
  DQsykN: "America/Havana",
  DVZRDC: "Europe/Oslo",
  DcYI27: "Africa/Maputo",
  "EGDZo+": "Asia/Srednekolymsk",
  EcRGq9: "Asia/Dubai",
  EgIxeE: "America/Jamaica",
  "EnTK+r": "America/Chicago",
  EqvKbF: "America/Cuiaba",
  F0y8e9: "America/Los_Angeles",
  F465cE: "Europe/Helsinki",
  F6OWRn: "Pacific/Port_Moresby",
  FDGDXD: "Europe/Kiev",
  FEnpn4: "Europe/Berlin",
  FeFqOa: "Asia/Choibalsan",
  "G0/1QH": "America/Paramaribo",
  "GHrEk+": "Asia/Ho_Chi_Minh",
  Gcuin4: "Asia/Ulaanbaatar",
  "H+kwCw": "Asia/Brunei",
  "H/TECz": "Asia/Seoul",
  H11GhT: "Asia/Khandyga",
  HD7dNh: "Asia/Qyzylorda",
  HDlqGj: "America/Argentina/Tucuman",
  HSmzBV: "America/Argentina/San_Luis",
  I2fe6r: "Asia/Hebron",
  ID5HGa: "Pacific/Guam",
  "IRsI+H": "Asia/Makassar",
  IVs8gT: "Indian/Mauritius",
  "IYKKU/": "Asia/Yerevan",
  IYSP57: "America/Santarem",
  JGg252: "Asia/Dili",
  "JJJ+wW": "Pacific/Wallis",
  JTTFhT: "Pacific/Kosrae",
  KBQ98i: "Europe/Sofia",
  L6RwvT: "America/Scoresbysund",
  LFkBwb: "Asia/Kuala_Lumpur",
  LGJGKo: "America/Indiana/Winamac",
  LepYst: "America/Argentina/San_Juan",
  LrC3cb: "Africa/Johannesburg",
  M74J18: "Pacific/Apia",
  "MS/dmQ": "Europe/Vilnius",
  MYvQtB: "Pacific/Pohnpei",
  MhFcna: "Asia/Aqtau",
  MpIqyW: "Asia/Novosibirsk",
  "N69J/J": "America/Cayman",
  N7RBEQ: "Europe/Paris",
  "NLL9E/": "Asia/Singapore",
  Nap8NB: "America/La_Paz",
  NhLpaB: "Asia/Gaza",
  NwiC8y: "Asia/Baku",
  OPz5aV: "Europe/Warsaw",
  "OSP/DU": "America/Araguaina",
  "OoH/k4": "Europe/Malta",
  OqlGXK: "Atlantic/Faroe",
  OtFyGC: "Europe/Zaporozhye",
  P9EyMh: "Asia/Almaty",
  PRo9ZX: "America/Grand_Turk",
  Pbr43k: "Pacific/Gambier",
  PdnZvE: "America/Indiana/Knox",
  Phhnuu: "Pacific/Guadalcanal",
  "PlA+93": "America/Anchorage",
  "Q+QFi7": "America/Panama",
  Q0Nwql: "America/Nassau",
  Q2hC7E: "Asia/Anadyr",
  RTFf0R: "Asia/Tashkent",
  RVtTvI: "America/Bogota",
  RcUwWS: "Europe/Tirane",
  Rfu8ru: "America/Juneau",
  RzRPhx: "Asia/Tehran",
  SRDvbw: "Indian/Christmas",
  SkSGFq: "America/Asuncion",
  SqYr66: "Pacific/Chuuk",
  T7X3nR: "America/Costa_Rica",
  TnMEvg: "Europe/Riga",
  TnQgWT: "Indian/Cocos",
  UE61nU: "Asia/Jakarta",
  UEbt0M: "Europe/Athens",
  UjOTtz: "Europe/Monaco",
  VlcnXa: "Atlantic/Azores",
  WICb5K: "Asia/Magadan",
  "WJ+FQF": "Asia/Tbilisi",
  WTSjw5: "Pacific/Pago_Pago",
  WUi6ng: "Asia/Kuching",
  WX1P13: "Antarctica/Davis",
  Wb2LCw: "Antarctica/Rothera",
  Wg0kce: "America/Indiana/Vincennes",
  WhpVLY: "America/Guayaquil",
  Wq4Z0k: "America/Belem",
  XK8hFK: "America/Rio_Branco",
  XLgiC3: "Pacific/Norfolk",
  XN4sjj: "Asia/Samarkand",
  XuXXK5: "America/Recife",
  YOJC0Y: "America/Indiana/Marengo",
  Yux40Y: "Antarctica/Palmer",
  "Z+d4VE": "Europe/Amsterdam",
  ZOXOj5: "Antarctica/Mawson",
  "aKg/xg": "Antarctica/Troll",
  "aqHEW/": "Africa/Algiers",
  aqZ1dw: "Pacific/Galapagos",
  aylTTV: "America/Curacao",
  "b5+eh2": "Asia/Baghdad",
  b5GT3E: "Africa/Bissau",
  bf8oMi: "Pacific/Kiritimati",
  bkKBAQ: "Asia/Pontianak",
  c5lOtj: "Asia/Vladivostok",
  cCvy0S: "America/Caracas",
  ciyA6X: "Asia/Manila",
  cl18LV: "Asia/Ust-Nera",
  d6W7pe: "Europe/Moscow",
  dw9A9j: "America/Argentina/Mendoza",
  e77Cv2: "Asia/Yakutsk",
  e88zL2: "Asia/Nicosia",
  eDz3Tw: "America/Adak",
  eJqVsD: "Europe/Gibraltar",
  "eR7v+R": "America/North_Dakota/Beulah",
  ekhdTj: "Asia/Jayapura",
  "f6G4/S": "Pacific/Auckland",
  f6r66H: "America/Menominee",
  fJpD6E: "Africa/Ndjamena",
  fqXfBN: "Europe/Rome",
  "fxAR+x": "Asia/Oral",
  g2HLMh: "Antarctica/Syowa",
  gU3Odo: "America/New_York",
  "gibo/e": "Europe/Vienna",
  gln1VX: "America/El_Salvador",
  guiUEK: "Europe/Bucharest",
  gycX1L: "America/Noronha",
  h5YZ1i: "Europe/Brussels",
  hI5EVU: "Indian/Reunion",
  hKq7PN: "Europe/Kaliningrad",
  hL3apR: "America/Lima",
  hZiOxa: "America/Puerto_Rico",
  hdgzx5: "Pacific/Easter",
  hrq9xi: "Europe/Minsk",
  iBXv4d: "America/Metlakatla",
  inPmEU: "Europe/Tallinn",
  jRwF7m: "America/Phoenix",
  jaNloj: "America/Maceio",
  jtTALf: "Pacific/Honolulu",
  k6R7DN: "America/Fortaleza",
  kLf0tS: "America/Detroit",
  lAz3SQ: "Asia/Bishkek",
  lNijTx: "Atlantic/Stanley",
  m5vKwe: "Asia/Kolkata",
  mXs7zw: "America/Sitka",
  mnvAEu: "America/Indiana/Tell_City",
  n8UW9y: "Asia/Yekaterinburg",
  nYFNxR: "Asia/Sakhalin",
  o5Rywj: "America/Argentina/Catamarca",
  oYmVJJ: "Asia/Krasnoyarsk",
  ocqIaV: "Indian/Chagos",
  ocqwXs: "Asia/Omsk",
  okHgMB: "Asia/Dushanbe",
  pKp9LP: "America/Indiana/Vevay",
  pNrCwc: "America/Manaus",
  pQ5zcx: "America/Argentina/Ushuaia",
  pcGYLU: "America/Thule",
  pvDJax: "America/Barbados",
  "q5++81": "Europe/London",
  q7mJWt: "America/Boise",
  "qSxe/X": "Europe/Zurich",
  rB9Ewl: "Asia/Aqtobe",
  rIY0ZR: "Indian/Maldives",
  rZTr8Y: "America/Indiana/Indianapolis",
  rhN321: "America/Godthab",
  rslOL6: "Pacific/Tarawa",
  rwZktH: "America/Argentina/Cordoba",
  s2obSj: "Pacific/Palau",
  s3GZlv: "America/Port_of_Spain",
  slYOe6: "America/Cayenne",
  szkWWk: "America/Bahia",
  t5CPbZ: "Europe/Dublin",
  tHE78L: "America/Santo_Domingo",
  tMDDnr: "America/Managua",
  tUaF1F: "Pacific/Niue",
  tlkIG3: "Pacific/Fiji",
  "tw/bjJ": "Asia/Novokuznetsk",
  u0TM9W: "America/Port-au-Prince",
  uMXTTe: "Europe/Stockholm",
  uNiOLq: "Asia/Jerusalem",
  "uOkO/r": "Asia/Irkutsk",
  "utbU0+": "Asia/Ashgabat",
  ux1XM2: "Atlantic/Bermuda",
  "v+arTX": "America/Eirunepe",
  vMATTy: "Asia/Damascus",
  "vWWiU+": "Asia/Pyongyang",
  vbHpIo: "Africa/Windhoek",
  vn9nKr: "America/Porto_Velho",
  vohVUs: "Asia/Kabul",
  vwtvCc: "Atlantic/Cape_Verde",
  vy4zY8: "Asia/Colombo",
  w7kHCL: "Atlantic/Madeira",
  wDFHDz: "America/Martinique",
  "wbQai/": "Atlantic/South_Georgia",
  wrZg4b: "Asia/Thimphu",
  xAcBeP: "Pacific/Tahiti",
  xKA8d6: "Antarctica/DumontDUrville",
  "xx+5iB": "America/Kentucky/Louisville",
  y79PlA: "Asia/Amman",
  yaBGO1: "Pacific/Pitcairn",
  yeltlL: "Indian/Mahe",
  ygabsP: "America/North_Dakota/New_Salem",
  z6KEn9: "Pacific/Rarotonga",
  z98zna: "Indian/Kerguelen",
  zWABd8: "Europe/Belgrade",
  zm3ZI2: "Asia/Shanghai",
  zwjmMl: "Asia/Kathmandu",
  "e5x+i6": "Australia/Lord_Howe",
  gAtxKw: "Antarctica/Macquarie",
  P5aTR8: "Australia/Hobart",
  "nFhe/c": "Australia/Currie",
  e6YJm8: "Australia/Melbourne",
  dmcxmV: "Australia/Sydney",
  jFnCUr: "Australia/Broken_Hill",
  i5MwAy: "Australia/Brisbane",
  WyjEwT: "Australia/Lindeman",
  JuasJd: "Australia/Adelaide",
  co8c88: "Australia/Darwin",
  qm4oIk: "Australia/Perth",
  "0LrMZs": "Australia/Eucla",
  "+E914Q": "French (Réunion)",
  "+FHEub": "Central Atlas Tamazight (Arabic)",
  "/AAqs8": "Portuguese (Equatorial Guinea)",
  "/BbMQN": "Sinhala",
  "/NVZFV": "Portuguese (Angola)",
  "/V7bTl": "Fula (Latin, Gambia)",
  "/YFnxw": "Saho",
  "/stiNv": "Thai",
  "019rDM": "Portuguese (Portugal)",
  "01GXUP": "Fula (Latin, Guinea)",
  "0BWpf+": "Japanese",
  "0CHkPh": "West Frisian",
  "0D82eT": "Croatian (Bosnia and Herzegovina)",
  "0fzUyn": "Portuguese",
  "0mDCSY": "Spanish",
  "0rqbd/": "Maltese",
  "160k/R": "Russian",
  "1BHQDP": "Bengali (India)",
  "1F0Uz0": "Arabic (Iraq)",
  "1J25kd": "Bosnian (Slavic)",
  "1RqABh": "Lithuanian",
  "1dv927": "Malay (Brunei)",
  "29JxAe": "English (United Kingdom)",
  "2LBIWM": "Inuktitut",
  "2OXQzm": "Danish",
  "2atqiI": "Oromo",
  "2hRVBA": "Serbian",
  "30RDW+": "Arabic (Qatar)",
  "3PyL86": "English (Philippines)",
  "3Rvul8": "Tibetan (India)",
  "3ijo+p": "Dutch (Suriname)",
  "4+Zl7y": "Spanish (El Salvador)",
  "4Od9+t": "Serbian (Slavic, Bosnia and Herzegovina)",
  "4U3ZpB": "French (Haiti)",
  "4Xzh0/": "Portuguese (Switzerland)",
  "4eGD8c": "Fula (Latin, Sierra Leone)",
  "4fkP4F": "Spanish (Cuba)",
  "4lbmZs": "Spanish (Philippines)",
  "4v0pnb": "Welsh",
  "51lnU8": "Colognian",
  "5KynFd": "Czech",
  "5cyBop": "English (India)",
  "5ff1Qr": "Tsonga",
  "5g+4ES": "Korean (North Korea)",
  "5riLBC": "Somali (Djibouti)",
  "5vu2sQ": "Uzbek",
  "5xPlEp": "Chinese (Traditional)",
  "62eqUV": "Northern Luri",
  "6AZb8G": "Inuktitut (Educational Curriculum)",
  "6G/CAW": "Belgian",
  "6am43/": "Central Kurdish",
  "6ebNfH": "Chinese (Simplified, Hong Kong SAR)",
  "6gtes0": "Central Atlas Tamazight",
  "6sur5u": "Danish (Greenland)",
  "7Gt5UH": "Sanskrit",
  "7k8oo8": "German (Austria)",
  "7wLEyk": "Manx",
  "7yHu97": "Latvian",
  "8MDM0L": "Tamil (Sri Lanka)",
  "8oEDHH": "French (Morocco)",
  "93yDUJ": "Southern Sami (Norway)",
  "9cbhiA": "Arabic (World)",
  "9ftsGr": "English (Malaysia)",
  "9ltErv": "Romansh",
  "9uEO2O": "Asturian",
  AAf440: "Sesotho sa Leboa",
  ALhR5U: "Quechua (Peru)",
  "AQfg7+": "French (Congo - Kinshasa)",
  AahSYM: "Uzbek (Arabic)",
  AeHTyT: "English (Hong Kong SAR)",
  "B+59h1": "Mongolian (Traditional Mongolian)",
  B8qZTI: "Armenian",
  B9ZGRE: "Lao",
  BFf5tN: "French (Canada)",
  BgGwdt: "Vietnamese",
  BpUgM5: "Dutch (Bonaire, Sint Eustatius and Saba)",
  BtqqJK: "Spanish (Honduras)",
  CBhHg6: "Fula (Latin, Nigeria)",
  CDbpEz: "Icelandic",
  CFRfr5: "Dzongkha",
  CauPny: "Catalan (France)",
  Ccf8zA: "Spanish (Uruguay)",
  DBHTS0: "English (Australia)",
  DMjlMC: "German (Belgium)",
  DW0c2K: "Spanish (Chile)",
  DzWKvp: "Georgian",
  "EP6mL+": "Manipuri",
  EREJay: "Sami (Lule)",
  EeOqFb: "Portuguese (São Tomé and Príncipe)",
  EzFn0W: "Dutch (Aruba)",
  F38yZH: "Somali",
  "FHLC+T": "German (Liechtenstein)",
  Fxzz1N: "Swedish (Finland)",
  FzgpJw: "Bengali",
  G7wzBO: "Arabic (United Arab Emirates)",
  "GF/5qr": "Tachelhit",
  GGLJ5z: "Corsican",
  GHtHh4: "Maori",
  "GRMM/R": "Alsatian (France)",
  "GZ+vSv": "Syriac",
  GnC74O: "Tibetan",
  GqQl0h: "Italian",
  GsOiFJ: "English (South Africa)",
  Gwyv4n: "Punjabi",
  "H/OHWA": "Filipino",
  H4fFDA: "Northern Sami",
  H73FDV: "Uyghur",
  "H7jT/h": "Albanian (Kosovo)",
  HDDkEc: "Zulu",
  HVCuT9: "English (Germany)",
  HZPa57: "Scottish Gaelic",
  "Hhe/Ef": "Spanish (Brazil)",
  Hj8GDj: "Gujarati",
  Hq92CJ: "Hawaiian",
  HqCNsI: "Norwegian",
  "I/+zqv": "English (Guernsey)",
  I42yCw: "English (Canada)",
  IC7HXP: "Tigrinya",
  IDCrtf: "Finnish",
  IEUJ0j: "German (Luxembourg)",
  "IR/BFt": "Somali (Ethiopia)",
  ItGyiB: "Kannada",
  Iz1WLp: "Urdu",
  J1rnrw: "Slovenian",
  J5rPWm: "Spanish (Ecuador)",
  JPFRXM: "English (Malta)",
  JVK3dg: "German",
  JkretN: "English (Finland)",
  Js4yYb: "Fula",
  "Jsem/p": "Mohawk",
  KDsjWJ: "Standard Moroccan Tamazight",
  "Kj/zcq": "French (Monaco)",
  LX0RZR: "Fula (Adlam)",
  Laghvq: "Kinyarwanda",
  Ll0N3I: "Cherokee",
  MESBkg: "Xhosa",
  MJQbru: "Bashkir",
  Mbp9v6: "Arabic (Syria)",
  Mt9Ngn: "Hebrew",
  N4oAho: "Sotho",
  NLZIcM: "Dutch (Belgium)",
  NObQUE: "Afrikaans",
  "NV+8r2": "Mapuche",
  NVQG0j: "Dhivehi",
  Nevbjx: "Fula (Latin, Mauritania)",
  NfTD2i: "Spanish (Venezuela)",
  NhbCYP: "Valencian (Spain)",
  NtuQMz: "Portuguese (Macau SAR)",
  "O/Bw0H": "Serbian (Latin, Kosovo)",
  OKUlj2: "Hungarian",
  OSMagZ: "French",
  Oju9iC: "Mongolian",
  P23feN: "Spanish (Belize)",
  "P91ei/": "Tajik",
  PE6jNM: "Spanish (Argentina)",
  PO8fNg: "Portuguese (East Timor)",
  POQTzM: "French (Senegal)",
  PSoXmh: "Odia",
  Pa7aMt: "Arabic (Lebanon)",
  Pl3tfG: "Swedish",
  PsNb95: "Irish",
  Q8eBZk: "Dutch",
  QBwWZp: "Oromo (Kenya)",
  Qcitp4: "Javanese",
  Ql51WU: "Marathi",
  R1VwTR: "Basque",
  R325ks: "Spanish (Latin America)",
  R34HBa: "Arabic (Oman)",
  RRmxSU: "Quechua",
  RTbzBi: "Upper Sorbian",
  RWrQ2K: "Arabic (Algeria)",
  "RqsM+G": "Spanish (Nicaragua)",
  SUF5bX: "English (Austria)",
  Sg9DRE: "French (Switzerland)",
  SlWjJ2: "Southern Sami",
  T9IHrN: "Luxembourgish",
  TQ7V9A: "Arabic (Morocco)",
  Tddnlb: "Telugu",
  Tq0aui: "Khmer",
  UAHDtf: "Malayalam",
  UGFi6Q: "Arabic (Jordan)",
  Uc1vOK: "Albanian",
  "V+BaHn": "Pashto",
  V223G2: "Fula (Latin, Burkina Faso)",
  V2uMRt: "Tamil",
  VJbQAt: "Spanish (Panama)",
  VKt1qn: "Nepali (India)",
  VuQRaN: "Italian (Switzerland)",
  W6zXNX: "Spanish (Dominican Republic)",
  WK7YIm: "Arabic (Yemen)",
  WQtbS0: "English",
  WU7Urn: "Turkish",
  WUUTG8: "Turkmen",
  Wlr6BV: "Catalan (Italy)",
  XAmFMw: "Croatian",
  XNXAkr: "Quechua (Ecuador)",
  XT8v2Z: "Catalan",
  XjbxJQ: "Afrikaans (Namibia)",
  Xkmde4: "Chinese (Simplified, Macau SAR)",
  Xx527p: "Northern Sami (Sweden)",
  Y7CQhy: "Swiss German",
  Y8mZTh: "English (Jamaica)",
  Y941O5: "Slovak",
  YNjb1t: "Faroese",
  Ygp3rn: "Bosnian",
  "Z/MVyq": "Church Slavonic",
  ZCh9e6: "Lower Sorbian",
  ZQtURc: "Romanian (Moldova)",
  ZjrmiJ: "Shona",
  "Zki/XJ": "Kazakh",
  a9U6ge: "Cornish",
  aO94Wj: "Urdu (India)",
  "aTZE+x": "Kashmiri (Devanagari)",
  aiXFTk: "Fula (Latin, Ghana)",
  bDNNJp: "Malay (Indonesia)",
  bLqBa4: "English (New Zealand)",
  bRIPjy: "English (Israel)",
  "bT+IsS": "Malay (Singapore)",
  bVuD3F: "Arabic",
  bfp8tQ: "Greenlandic",
  c3rP5p: "English (Slovenia)",
  cJbw13: "Chinese (Traditional, Taiwan)",
  cQRIur: "English (Singapore)",
  d5MtIX: "Indonesian",
  dEIOuD: "Polish",
  dPzT2w: "Breton",
  drEx3O: "Swahili",
  e9Fovw: "Papiamento",
  eGmwHh: "English (Switzerland)",
  eSg76K: "English (Gibraltar)",
  eSmbEf: "Irish (United Kingdom)",
  eWnJnC: "Hindi",
  efy66J: "Chechen",
  "f+NB92": "Spanish (Peru)",
  "f/8iNS": "Fula (Latin, Cameroon)",
  "f5+iem": "Spanish (Mexico)",
  f6Viji: "Pashto (Pakistan)",
  fkHabQ: "K'iche'",
  fv9aDa: "Sami (Inari)",
  "gHco+M": "Russian (Moldova)",
  gOsLMk: "Malagasy",
  gWx9ey: "Serbian (Latin, Montenegro)",
  gfmlPE: "English (Ireland)",
  glnMAY: "Tachelhit (Latin)",
  gvaI7A: "Somali (Kenya)",
  "h6q+Tn": "Prussian",
  h9YX8r: "Tamil (Singapore)",
  "hEPDg/": "Occitan",
  hNSwvJ: "Fula (Latin, Liberia)",
  hcX72z: "Tamil (Malaysia)",
  hmzrxz: "Northern Sami (Finland)",
  hr7Bt0: "Portuguese (Guinea)",
  i4jvwu: "Chinese",
  "i5/TH8": "Spanish (Equatorial Guinea)",
  "iI431+": "English (Netherlands)",
  iKxsEO: "Nepali",
  iTiaM1: "Guarani",
  iXn58z: "Azerbaijani (Slavic)",
  ifdXl3: "Korean",
  jG6ZfL: "German (Italy)",
  jGXHMX: "Serbian (Latin, Bosnia and Herzegovina)",
  "jHvE/3": "N'Ko",
  joVZ4M: "Arabic (Egypt)",
  "k+bU6l": "Dutch (Sint Maarten)",
  k6RCbu: "Portuguese (Luxembourg)",
  kW1ixl: "Swahili (Uganda)",
  l8f1rC: "Kashmiri",
  lGAoQJ: "Swahili (Tanzania)",
  "lig/ia": "Bodo",
  lwerC3: "Spanish (United States)",
  "m+zQs1": "Igbo",
  m421XM: "Ukrainian",
  "mP+2ZR": "English (Trinidad and Tobago)",
  mQ30Fl: "English (Falkland Islands)",
  mQPNAb: "Sindhi",
  mgFsmM: "English (Denmark)",
  "mkyn/R": "Arabic (Bahrain)",
  mq4oU3: "English (Jersey)",
  mvxq4r: "Galician",
  n86rIs: "Kyrgyz",
  naThLg: "Greek",
  ncJAOw: "Burmese",
  nfKkEe: "Fula (Latin, Niger)",
  nzfKPJ: "French (Cameroon)",
  "oCgi+u": "Amharic",
  "oh7xe+": "Sami (Lule, Norway)",
  oiHWuC: "German (Switzerland)",
  ono6Zw: "Spanish (Guatemala)",
  ouSGKF: "Sami (Skolt)",
  pJE11U: "Setswana (Botswana)",
  pVxDdM: "Mazanderani",
  pcWfuB: "Setswana",
  pdfcvu: "French (Ivory Coast)",
  pjF6Nn: "Sotho (Lesotho)",
  pqIrOS: "Arabic (Tunisia)",
  q2N4yn: "Serbian (Slavic)",
  qQDW8M: "French (Mali)",
  qRbMrx: "Yoruba",
  qYdUNv: "Central Atlas Tamazight (Tifinagh)",
  qu9gJ5: "Arabic (Libya)",
  qwSYAN: "Portuguese (Mozambique)",
  r8ZWqf: "Nynorsk Norwegian",
  rcixhA: "Dutch (Curaçao)",
  rcmyN3: "Persian (Afghanistan)",
  rk5DA1: "English (Belgium)",
  sBC8AY: "Sindhi (Devanagari)",
  sHbxv8: "English (Belize)",
  sRuB7H: "Malay",
  sl0qaQ: "Arabic (Kuwait)",
  sliV2n: "Spanish (Paraguay)",
  syMU2g: "French (Belgium)",
  tQJpug: "Catalan (Sardinia)",
  tQi27b: "Konkani",
  tRgqyZ: "Serbian (Slavic, Kosovo)",
  tdrfAE: "English (Caribbean)",
  u0KReQ: "Italian (Vatican City)",
  u61cWR: "Spanish (Colombia)",
  u78bW4: "Macedonian",
  uCI04p: "Estonian",
  uVRPPZ: "Tatar",
  ubfX8q: "English (Zimbabwe)",
  uh1OQN: "Wolof",
  upv4s2: "Portuguese (Cape Verde)",
  vSG3D5: "Spanish (Costa Rica)",
  viRRMu: "Serbian (Slavic, Montenegro)",
  vo99Cy: "English (Burundi)",
  vuf8EY: "English (British Virgin Islands)",
  vxR1y4: "Hausa",
  wVqnrV: "Persian",
  wra0CG: "Swahili (Congo)",
  wtZRFn: "Friulian",
  x0KMJr: "English (Isle of Man)",
  xXkK79: "Mongolian (Traditional Mongolian)",
  xeXtGt: "English (Sweden)",
  xgB0JY: "Assamese",
  xoMuR7: "Walser",
  "xzWaZ/": "Spanish (Puerto Rico)",
  "y//NHV": "Azerbaijani",
  y7nOlh: "Bulgarian",
  ydTOo2: "French (Luxembourg)",
  z0tSbC: "Ossetic",
  z1VBi8: "Romanian",
  zBWf5p: "Interlingua",
  zWU1xI: "Spanish (Bolivia)",
  "05KCjo": "App icon:",
  "11uVJ/": "Receiving object",
  "1Qoc6t": "Process Name:",
  "2JW1Pt": "Please select whether to send email at the same time",
  "70JpVD": "Process Name",
  "9AsSO/": "Please select whether to send SMS at the same time",
  "AH+jWQ": "Windows Application",
  Axagls: "Please Select End Time",
  FNIJXx: "Please Select Scrolling Play",
  Fir0oq: "Please Select Notification Type",
  G4qgGm: "All Users",
  G5gg2V: "Announcement title is required",
  IWPf2S: "Announcement details",
  IbWDVg: "Version number is required",
  Km733q: "Please select start time",
  L24ioQ: "Title",
  L80hmc: "Announcement title cannot exceed 30 characters",
  NDjXUx: "Enter the command to deploy the file:",
  "Oex59+": "Return To List",
  QHc9Qg: "Announcement Content",
  QNomO6: "Please enter the version number",
  Qpcx6F: "Announcement content is required",
  RQyKsa: "Platform announcement",
  TiK9WZ: "Process name is required",
  TvOGLc: "Deployment File Instructions",
  UHuNzJ: "Please Enter Instructions",
  WtPk7v: "Send SMS at the same time",
  XbIN5K: "Please Enter The Program Name",
  XeIKK7: "Notification Center",
  ZqioaF: "Notification Title",
  aGxRt2: "Content",
  cr1ymH: "Please select the sending time",
  dY3og7: "Upload App Icon:",
  eFDqHN: "Upload Windows Application Successfully",
  eSfTZf: "Upload Windows Application",
  "ghKe/+": "Process Name",
  "h5yj+x": "Please enter the process name",
  jAJbuk: "Notice Announcement",
  l36W55: "Scrolling Play",
  lqQKL4: "Add By Process Name",
  mKKd1R: "Please select the recipient",
  q9PHLT: "No announcement yet",
  wYygRu: "Sender",
  xXdMar: "Specified User",
  xx40g7: "Announcement Title",
  yKFvYY: "Send email at the same time",
  yfhtRM: "Attachment",
  z5L9EV: "Update Windows Application",
  "bhv+8O": "Downloading",
  xzmRTb: "Only display the history of the past 7 days",
  "yrR/HC": "Installing",
  "6oXjFu": "The upload format is incorrect",
  KetfTt: "Maximum image size: 500KB",
  baNBmh: "The image size cannot exceed 500KB!",
  tAjFr2: "Images: PNG, JPG, JPEG, BMP, GIF, SVG, WEBP",
  ibYzs0: "Program Name: {name}",
  ivzCMK: "The application cannot be resolved.",
  mJBhe1: "File synchronization allows up to 10 files to be added",
  "3K02K/": "Incomplete WiFi configuration filling",
  "5Cm9U3": "Notify",
  "Y6Q+iJ": "Please fill In the WiFi configuration",
  tugHWJ: "Return to Announcement List",
  "x/FhNQ": "View Notifications",
  "+GRUnH": "Asia/Khovd",
  "+IL2pH": "Asia/Riyadh",
  "+J2Dyk": "America/Asuncion",
  "+Ny8AK": "America/Puerto_Rico",
  "+RWig5": "Spanish (Bolivia)",
  "/2Wzyw": "America/El_Salvador",
  "/rG/9z": "America/Curacao",
  "0AuprP": "Pacific/Tongatapu",
  "0X3KFO": "CPU Temperature",
  "0vIw5o": "America/Bogota",
  "1YfhFP": "Asia/Dili",
  "2+A7qs": "Antarctica/Mawson",
  "2+ec6P": "America/Danmarkshavn",
  "2FPNxz": "Asia/Dubai",
  "32RJkL": "America/Argentina/San_Luis",
  "33VS8L": "America/Maceio",
  "36csPo": "Europe/Zurich",
  "3KlQfs": "Australia/Brisbane",
  "3LAnU7": "Atlantic/Faroe",
  "3MaR6w": "Europe/Tallinn",
  "3NE037": "Asia/Ashgabat",
  "3svavz": "America/Miquelon",
  "42xSxy": "Asia/Novosibirsk",
  "4LAo5S": "America/Metlakatla",
  "4Sw/d9": "Asia/Krasnoyarsk",
  "4T/bEM": "America/Indiana/Vevay",
  "4WaJo8": "America/Scoresbysund",
  "4Wgk5f": "Europe/Andorra",
  "4ZRHuu": "Atlantic/South_Georgia",
  "4cXOI/": "Asia/Yerevan",
  "4jryq3": "America/North_Dakota/New_Salem",
  "4sqSH4": "Asia/Khandyga",
  "564gFy": "Africa/Accra",
  "6SQvm5": "Asia/Pontianak",
  "6X6msx": "Storage Usage",
  "6xnHrJ": "Europe/Berlin",
  "72KWoU": "Australia/Sydney",
  "778/Xc": "America/Tegucigalpa",
  "7JA1Vf": "America/Argentina/Mendoza",
  "7L+CJm": "Europe/Helsinki",
  "7geAkY": "America/Argentina/Buenos_Aires",
  "7teo40": "Pacific/Chuuk",
  "87d7yX": "Pacific/Guadalcanal",
  "8Gi8qJ": "Australia/Broken_Hill",
  "8eL/hC": "Asia/Jerusalem",
  "8hJsOE": "Asia/Bangkok",
  "8qYKWy": "Pacific/Chatham",
  "8woxjy": "Asia/Kuala_Lumpur",
  "A3y/jB": "America/Argentina/Rio_Gallegos",
  ACHtOA: "Asia/Kamchatka",
  AFZYEo: "Asia/Brunei",
  ALGNzc: "Asia/Magadan",
  AWhHY3: "America/Rio_Branco",
  ApnLV0: "Asia/Almaty",
  AqKGKn: "Asia/Jakarta",
  As1lP0: "Indian/Kerguelen",
  "Aytpe/": "Europe/Monaco",
  B6rikn: "America/Indiana/Indianapolis",
  B9NkmN: "Europe/Luxembourg",
  BXdJNy: "Atlantic/Stanley",
  BgYCgo: "Antarctica/Casey",
  C21hEn: "Europe/Belgrade",
  C7HjWu: "Europe/Amsterdam",
  CBkGYl: "Africa/Maputo",
  CC9Jw3: "Asia/Makassar",
  CIImWq: "Pacific/Majuro",
  "CNMmH/": "Asia/Yakutsk",
  CR8w2m: "America/Grand_Turk",
  CUsFOe: "America/Cayenne",
  D2gXtv: "America/Menominee",
  D4VBw5: "Antarctica/DumontDUrville",
  DincSy: "Australia/Lord_Howe",
  DoPuye: "Asia/Damascus",
  "E/3oPZ": "Asia/Macau",
  E2NUw6: "Africa/Johannesburg",
  EJA24j: "Pacific/Norfolk",
  EgGVTj: "Pacific/Enderbury",
  EhPWhM: "America/Cuiaba",
  EmxcJt: "America/Yakutat",
  Ewhh7n: "Europe/Sofia",
  FXD37C: "America/Panama",
  FsXquv: "Asia/Pyongyang",
  GIHcco: "America/Godthab",
  GIwuGT: "Europe/Brussels",
  GNkv6K: "Africa/El_Aaiun",
  "H8+X66": "Asia/Khandyga",
  HDVqMh: "America/Argentina/San_Juan",
  HEpXP8: "America/Denver",
  HOEyDX: "America/La_Paz",
  HS4Jyv: "Europe/Uzhgorod",
  Hh1tUP: "America/Guayaquil",
  HkGIFU: "Antarctica/Davis",
  HoSy6c: "Pacific/Kwajalein",
  HuSwkp: "Asia/Ust-Nera",
  HzSbcD: "Antarctica/Troll",
  I3bX6d: "Asia/Urumqi",
  IBZBgD: "Europe/Istanbul",
  IHXrCK: "America/Los_Angeles",
  IKeroX: "Asia/Jayapura",
  ILjenb: "America/Indiana/Marengo",
  IgbKn9: "Asia/Ho_Chi_Minh",
  InLlSF: "America/Paramaribo",
  J5iABC: "Asia/Karachi",
  JHjx5l: "America/Anchorage",
  "JURm/W": "Antarctica/Palmer",
  "Jc5/LG": "Asia/Omsk",
  JrjIBq: "America/Port-au-Prince",
  K9TF6H: "Asia/Hong_Kong",
  KAKu2d: "Pacific/Noumea",
  KEr7iI: "Pacific/Palau",
  "KaS+yS": "America/Costa_Rica",
  KyBesr: "Pacific/Rarotonga",
  M3Bd2i: "Pacific/Pitcairn",
  MAVhWe: "Europe/Oslo",
  MAWdwn: "Asia/Colombo",
  McxhaP: "America/Belize",
  MeSuny: "America/Barbados",
  MmTr9O: "Africa/Cairo",
  Mr4JiU: "Indian/Chagos",
  MxWLCa: "Pacific/Marquesas",
  NW4CG5: "Africa/Tripoli",
  NWpmvK: "Europe/Moscow",
  Nd0dlz: "America/Argentina/Catamarca",
  NhHERf: "Africa/Khartoum",
  O2VzkZ: "Europe/Gibraltar",
  OEWR5m: "America/Recife",
  OPvCOV: "Atlantic/Reykjavik",
  OdITFl: "Indian/Cocos",
  Oj7H2e: "Europe/Malta",
  OnT6Rq: "America/Argentina/Salta",
  P5ijks: "Asia/Chita",
  P8Gz8g: "Asia/Samarkand",
  P8fuMA: "Pacific/Apia",
  PE4Jv1: "Europe/Kaliningrad",
  "PHe5b/": "America/Sao_Paulo",
  PQTASm: "Africa/Nairobi",
  PSTE5v: "Asia/Tehran",
  "Pr/HJJ": "America/Thule",
  Q93ucv: "Europe/Dublin",
  Q9eZjv: "America/Lima",
  QIrZ4x: "Pacific/Kosrae",
  QXW2mv: "America/Argentina/Tucuman",
  QlNyHt: "Asia/Seoul",
  RWGdDh: "Europe/Bucharest",
  RWhf30: "Pacific/Auckland",
  RbCEhx: "America/Kentucky/Louisville",
  RdB8rs: "America/Kentucky/Monticello",
  Ri5GFC: "Europe/Volgograd",
  Rzjtg0: "Antarctica/Macquarie",
  "SB+r6t": "Indian/Christmas",
  "SDmnE+": "Asia/Amman",
  SO2rVX: "Africa/Windhoek",
  TSIb1O: "Asia/Beirut",
  TVzP2K: "Pacific/Easter",
  TmXGJf: "Pacific/Pago_Pago",
  Tp6vAo: "Atlantic/Azores",
  "Tvk1/+": "Asia/Baku",
  TxnfAW: "Europe/Simferopol",
  UU6RxP: "Pacific/Fakaofo",
  "W+BF0N": "Europe/Kiev",
  WF6jLL: "Asia/Irkutsk",
  WGbNbT: "Europe/Rome",
  WH83gM: "Australia/Eucla",
  WM9F6N: "Europe/Budapest",
  WT4u2Q: "Africa/Bissau",
  Wd588a: "America/Juneau",
  "X+krOQ": "Europe/London",
  XG3VTC: "Indian/Maldives",
  XGLQKt: "Indian/Mauritius",
  XJz9XQ: "America/Chicago",
  XcLHzQ: "America/Santo_Domingo",
  XgCqrC: "Asia/Kuching",
  "Xs2qb/": "Asia/Shanghai",
  YUT4gj: "Europe/Lisbon",
  YZ2GGD: "Asia/Singapore",
  "Ywxpi/": "Indian/Mahe",
  Z0uRcM: "Asia/Dhaka",
  ZKdJhk: "America/Boa_Vista",
  ZZib2d: "Australia/Hobart",
  Zjiy1h: "Pacific/Nauru",
  ZnA7Nz: "Asia/Hebron",
  a25tfu: "Asia/Kolkata",
  a4hALt: "Europe/Samara",
  aIkFIc: "Europe/Riga",
  aJXo8B: "Asia/Sakhalin",
  an8KV9: "Europe/Stockholm",
  "bPKD9+": "America/Bahia",
  bpugpH: "Pacific/Galapagos",
  bwibOg: "America/Indiana/Tell_City",
  bwxucD: "Antarctica/Rothera",
  byIMHD: "America/Indiana/Winamac",
  cGo7xU: "Europe/Vienna",
  cL4iBR: "Pacific/Wake",
  cR6lQr: "America/New_York",
  cY9R69: "Asia/Yangon",
  "cdP+DQ": "Memory Load",
  cfqioE: "America/Martinique",
  ckkIgb: "America/Santarem",
  "d+p45H": "Antarctica/Station",
  "dD/ri/": "Pacific/Efate",
  dVOPAi: "Device Offline Monitoring",
  dmQidl: "Pacific/Wallis",
  dnhrx5: "Europe/Athens",
  dsc2e1: "America/Campo_Grande",
  dwtkZ7: "Atlantic/Cape_Verde",
  e7x56t: "America/Eirunepe",
  eCaCt4: "Europe/Copenhagen",
  eJ850A: "America/Caracas",
  eUPrSB: "America/Argentina/Cordoba",
  "eiH+8b": "Africa/Ndjamena",
  esrASO: "America/Manaus",
  "f/kdJq": "Asia/Dushanbe",
  f2wvqe: "Asia/Qyzylorda",
  fRTjpp: "America/Port_of_Spain",
  felOXC: "Europe/Minsk",
  "fr++q+": "America/North_Dakota/Center",
  fwXmSX: "Indian/Reunion",
  g8yytK: "Read",
  g9Ro8s: "Asia/Thimphu",
  gCnWv3: "America/Guatemala",
  "gWP+OK": "America/Porto_Velho",
  gY9Idz: "Notification Content",
  hMJvQy: "Asia/Aqtobe",
  hMvFT8: "Pacific/Fiji",
  i9kfO3: "Australia/Perth",
  ia2KGW: "Australia/Lindeman",
  iemojj: "America/Indiana/Petersburg",
  iktlFx: "Africa/Lagos",
  ioR1tU: "Australia/Melbourne",
  irTGxZ: "America/Nassau",
  iuG5L2: "Pacific/Funafuti",
  jArote: "Asia/Choibalsan",
  jGg3Qb: "Atlantic/Bermuda",
  "kPnKK/": "Pacific/Tarawa",
  kQfkBY: "Pacific/Niue",
  kX80z5: "Africa/Casablanca",
  kb4vnt: "Asia/Tbilisi",
  kibwvT: "America/Araguaina",
  klPlFN: "Atlantic/Madeira",
  ktaxSw: "Unread",
  kzL66g: "America/Sitka",
  l0DTVX: "Europe/Chisinau",
  l3HZXk: "America/Argentina/Jujuy",
  lUObgG: "Asia/Novokuznetsk",
  "lY+G1f": "Europe/Zaporozhye",
  ldw5JF: "America/Havana",
  ldz3Qp: "America/Nome",
  "luv+ak": "Antarctica/Showa",
  m372k4: "Asia/Aqtau",
  mC90qt: "America/Fernando_de_Noronha",
  maWrSV: "Asia/Qatar",
  mpmcYh: "America/Jamaica",
  mzw9vO: "Asia/Vladivostok",
  nFRGgT: "Asia/Nicosia",
  nG6bDa: "Pacific/Pohnpei",
  nNIaxy: "Australia/Currie",
  "nTx/do": "Africa/Monrovia",
  ndfOI1: "Asia/Tashkent",
  nfV4cd: "Pacific/Port_Moresby",
  nt7Sni: "America/Phoenix",
  "oNgMl/": "Europe/Warsaw",
  ox9xcC: "Asia/Ulaanbaatar",
  "p/Y+A9": "Asia/Oral",
  p60kqM: "America/Indiana/Knox",
  "pDAAq+": "Pacific/Christmas",
  "pH7u/B": "Europe/Prague",
  pctdGN: "Pacific/Tahiti",
  pkQvvT: "Asia/Gaza",
  qZesUE: "Pacific/Bougainville",
  qm1rPH: "America/Adak",
  qrxb3P: "America/Managua",
  qyspJO: "Asia/Baghdad",
  rB8hza: "America/Boise",
  rDnYpj: "America/Detroit",
  "rSU+yK": "Europe/Tirane",
  rhrAj5: "Asia/Manila",
  sCbQzB: "Pacific/Guam",
  ssEhAp: "Australia/Darwin",
  tGy5jw: "Asia/Bishkek",
  tb5CXr: "Europe/Paris",
  u8OEeb: "Asia/Anadyr",
  umaIEg: "America/Argentina/Ushuaia",
  "uq/hF0": "Asia/Tokyo",
  v1R8a6: "America/Guyana",
  v9QImt: "Asia/Kabul",
  vvPXpH: "Asia/Kathmandu",
  w6MqYv: "America/Belem",
  "wHl/4A": "Australia/Adelaide",
  wQ6hxa: "Africa/Tunis",
  wTov5v: "America/Fortaleza",
  wu6z2j: "Pacific/Gambier",
  xC5dF9: "Africa/Algiers",
  xV1AHg: "Asia/Yekaterinburg",
  xV72W5: "America/Santiago",
  "xefyX+": "America/North_Dakota/Beulah",
  yBB7Af: "America/Argentina/La_Rioja",
  yjTwMp: "Asia/Taipei",
  yk6eIX: "Pacific/Honolulu",
  z4BN1R: "America/Cayman",
  zMTRSM: "CPU Load",
  zOIpOr: "America/Indiana/Vincennes",
  zooIwl: "Europe/Vilnius",
  "/+bsEl": "America/Monterrey",
  "/Gtqfz": "America/Merida",
  "22S38U": "America/Atikokan",
  "3TyuhP": "America/Ojinaga",
  "3nz5UA": "Africa/Abidjan",
  "5LGVs8": "America/Inuvik",
  "5hwp3A": "America/Winnipeg",
  "75rZvt": "America/Fort_Nelson",
  B1cpxi: "America/Bahia_Banderas",
  DB1i32: "America/Chihuahua",
  EjYbG7: "Atlantic/Canary",
  JJlhYG: "America/Moncton",
  JK7opY: "America/Rainy_River",
  JMiQE7: "America/Swift_Current",
  JNgj9q: "America/Vancouver",
  LQs9br: "America/Creston",
  TV0vfT: "America/Hermosillo",
  TtsBNI: "America/Santa_Isabel",
  "V/ychw": "America/St_Johns",
  V3RDY8: "America/Cambridge_Bay",
  WrrSc3: "Europe/Madrid",
  XAJf4I: "America/Yellowknife",
  Xf2rFn: "America/Mazatlan",
  "YIziP+": "America/Rankin_Inlet",
  Zw6GOE: "America/Regina",
  cvhrwM: "America/Pangnirtung",
  d4TeTf: "America/Whitehorse",
  dS4Q9B: "America/Edmonton",
  dXgU6w: "America/Matamoros",
  damxMJ: "America/Nipigon",
  hrTtyK: "America/Dawson_Creek",
  i7y8PO: "Africa/Ceuta",
  mYnwj6: "America/Iqaluit",
  mZSYZK: "America/Cancun",
  n4UQqL: "America/Dawson",
  pIep8S: "America/Mexico_City",
  pZHBxH: "America/Resolute",
  puzgCP: "America/Toronto",
  sf6FE5: "America/Glace_Bay",
  trLh1J: "America/Tijuana",
  vmXV5r: "America/Blanc-Sablon",
  x062Q4: "America/Halifax",
  x5t5ol: "America/Thunder_Bay",
  x8MKpa: "America/Goose_Bay",
  qhku2P: "(Windows 7 is not supported yet)",
  LjaYAu: "(The device will automatically restart after applying this setting)",
  SsOQaU: "Android device path must be set",
  ftJgyV: "A device must be checked",
  tp71Dv: "Windows device path must be set",
  "+x/2kt": "Device Rules",
  "781mpm": "3. Company default naming rules",
  EJYMZz:
    "After turning it off, you can download the new version of Ora and install it yourself, or manually update it through the device command - Ora update.",
  QWNGGT: "Number of Devices",
  QkSHo2:
    "After turning off automatic updates, differences in Ora versions on the device may cause some functions to be unavailable",
  RFear4: "2. Device Update Time (Local Time)",
  VUYwkz: "Please select an application",
  Z8Wkvb:
    "After turning it on, if there is a new version of Ora, it will be automatically downloaded and updated.",
  bc4BgP: "Ora last online time",
  c5daOt: "Number of stores ({num})",
  qDHqff: "Automatically Restart",
  zbqD5q: "Value",
  FtTdh0: "1. {ora} Automatic Update",
  Em0SLE: "Restart",
  Gvm3Ry: "Are you sure to restart {appName} of ({name})? Application monitoring will continue after restart.",
  Ixi8kg: "Restart Reminder",
  bbMhTk: "Are you sure to restart?",
  "99tjyG": "IP",
  "9a/nvJ": "Operation Result",
  BdDDD0: "Device Log",
  MbqxKj: "Template Name",
  OjLqmy: "Unknown",
  V6d4dz: "Operation Details",
  "hD/l+2": "Operation Type",
  "s+OQvW": "Operator",
  yc8eep: "Selection Result",
  "/5RjKG": "Token Expiration",
  "0nwYmb": "All",
  "ZC7J/S": "Type",
  pm5kAg: "Please view the content in details",
  y8e4w8: "This setting will take effect only after the device is restarted.",
  vjxfR4: "(exe installation program, MSI file)",
  "8DORrA": "USB Port",
  AFx0WP: "Search Type",
  GyqBiS: "Printer Information",
  L3HWwz: "Device Description",
  OuXnTb: "Are you sure to reset the USB port?",
  "QZM++f": "Are you sure to reset the printer?",
  RCjVsb: "Device ID",
  RJpihQ: "Are you sure to disable the USB port?",
  adMZWx: "Add Peripheral Device",
  j3iWkN: "Printer cannot be repeated",
  kL3ndq: "Do you want to remove the printer?",
  r8lAlx: "Peripheral Management",
  wIFJtf: "Not Connected",
  zKsJJS: "Are you sure to enable the USB port?",
  "zY36V+": "Connected",
  "2Rco7+": "Upload time:",
  "5JrKIs":
    "Function deployment has been scheduled for the selected release time.",
  E62yo0: "Function deployment failed, retrying.",
  HI9nIp: "Remove file",
  IX5jed: "Profile Deployment Status",
  Mxw3XE: "The bat file is not named install or uninstall",
  "N3h+Aq": "Function deployment failed",
  N9kr00: "Uninstall app after transfer",
  "OY+bYK": "Confirm, do not show again",
  PZD5BD:
    "This item is used by the [{name}] profile and cannot be deleted. If you want to delete the item, please remove the item in the profile",
  Pzsa4g: "Function deployment is ready",
  RzXkm3: "Blacklist enabled",
  SzN0Xf: "Remove Device Owner",
  VvutjQ: "Function",
  XPoLPc: "Function deployment has been received and will be processed soon.",
  Xsx53E: "Are you sure you want to remove this file?",
  c7ABGP: "Function deployment is waiting for Ora's response",
  d6mNdO: "Whitelist enabled",
  f9tP6e: "Are you sure you want to remove this Windows application?",
  hmCei2: "Uninstall app after removal",
  ii1TCF:
    "(Please name the bat file in the compressed package as install or uninstall)",
  mmGD7U: "Function deployment is in progress.",
  uL4MGN: "Are you sure you want to remove this Android application?",
  wzPSgE: "Blacklist/whitelist",
  xAk1ic: "The function has been successfully deployed",
  yWzW01: "(exe installer, msi file, zip compressed package)",
  yvnu2T: "Configuration template name",
  "CqT/5i": "This file has been shared. Are you sure you want to remove it?",
  wboZY3: "Report Time",
  "6kNt8v": "Next hour",
  Rkh3mc: "Previous hour",
  "+/nbWD": "Next changeable time {time}",
  "1ULJr+": "Single application mode",
  CxuMXm: "Must add an application",
  Gp3iu0: "Upload local wallpaper",
  M0GExq:
    "If the device already has the app, remove the original version and reinstall it",
  OYWCEU: "Local upload application",
  PyHYs3: "Close VNC connection",
  QZCAIP: "Application ID",
  "X+8ega": "Kiosk mode selection",
  "bLP2/B": "Check the setting application status",
  bneXBI: "Change prompt",
  czLSET: "Manually add an application",
  eg9Cwk: "From the current location company",
  f8ijF3: "The command has been issued",
  i8wqAy: "Upload local application",
  oiRBSj:
    "After confirmation, the device will apply the new settings. Are you sure you want to apply it?",
  "qG2/EZ": "Local file upload",
  "qH+vs7": "Whitelist",
  qTgFpp: "From the company to which the account belongs",
  qwHBkg: "No record of setting changes, all devices use the default settings",
  sB85Wu: "Local upload",
  uqEE8V: "This configuration is only applicable to Android Ora 2.14.25",
  vtUGfp: "Company Default Naming Rules",
  QgHuyM: "Merchant Naming Rules",
  "+Bas2b": "Duration: {duration}",
  "+a6DnG": "Under Review",
  "/CFd+q": "Enable",
  "0JQoTX": "Review Failed",
  "0Ru5zG": "Size: {size}",
  "0UhE3z": "Playback Status",
  "0btyN9": "Duration:",
  "1/U2kj": "Video",
  "1qoi3T": "Image",
  "3HqLlX": "New Content",
  "4jU7ke": "{nubis} Cast Mode",
  "4nG/GN": "Content Name",
  "5RR9aM": "Batch Pause",
  "5XSNyG": "Uploaded Materials Successfully",
  "6K/a0B": "Pause",
  "6wAcmz": "Please Select Time",
  "7M1nFY": "Are You Confirming to Delete Template {name}?",
  "7OW60G": "Clear Select Time",
  "7Ouq4k": "Order: {sort}",
  "7cAtfM": "Times",
  "7wofGo": "Apply",
  "9c8SPP": "Resolution",
  BhWZJo: "Resource Name",
  C55Kjj: "Playback Content",
  "D+32Ow": "Media Library",
  EBMdAL: "Created Successfully",
  ECm6hH: "Are you sure you want to delete this resource ({name})?",
  "ELFG/t": "Search Device",
  IP9Kbk: "Images cannot exceed 15MB",
  Ie9WHB: "Upload Material",
  KOVFgK: "Awaiting Review",
  "Lqca+c": "{nubis} Cast Launch",
  MDACCo: "Playback Successfully",
  MWJG8I: "Name: {name}",
  "Ut8+i2": "Approved",
  "Xi/+KE": "Add Time Slot",
  YuZxve: "Select Content",
  bKLb1C: "Play",
  bYujGa: "Create a Template",
  fFaC3Z: "Playback Settings",
  gVXoXc: "Content Management",
  i9lOCU: "The start date you selected is earlier than today",
  iHQiQV: "Batch Play",
  iJIOBp: "Parsing failed",
  "iRR+fJ": "debugInfo",
  l9XE8F: "Passed",
  lchpP8: "Apply Successfully",
  m8CFrl: "Create New Template",
  nbp4U6: "Content Template List",
  oUgWVb: "Type: {type}",
  "p/EHrl": "The maximum video size cannot exceed 10GB",
  qx5UwR: "Please select a device",
  rBWtYz: "Latest Change Time",
  rnpMD3: "Disable",
  sux9FA: "Input lower limit: 1",
  tRm3bw: "Pause Successfully",
  uhTa0i: "Preview",
  w1cMGO: "End Date",
  ztKQno: "Duration",
  J3dxzb:
    "Nubis currently supports the JPEG and PNG image formats. The video must be encoded using the H.264 codec. The supported file formats are MPEG-4 and MOV. A codec is software or hardware that compresses data for faster delivery and decompresses received data into its original form. The H.264 codec is commonly used for the recording, compression and distribution of video content. A video file format may contain one or more codecs. If your MOV or MPEG-4 format video file does not approved, check that the codec used to encode the video is H.264.",
  "M5Vtr/": "Edit Template",
  b1xi4S: "Preview Template",
  kNhfaL: "Are you sure you want to delete template ({name})?",
  kqgd4D: "Add at least one execution time.",
  "36pf2y": "Content History",
  "3izvEF": "Select File",
  "9mG+jv": "File Size Exceeds Available Space",
  AlFkwq: "Number of Installed Devices",
  C8ZuKU: "Image Width",
  E0Czos: "Image Height",
  I73XLQ: "Image Y-axis",
  JbroVc: "Nubis Cast",
  MMqJtu: "Must Select an Image or Video",
  "Pv/1oy": "Content Display",
  Rrwy85: "Creator",
  T8Y38H: "Image File (*.jpg/*.png)",
  VJ7wHx: "Number of Devices to be Installed",
  WI3Hl5: "Video X-axis",
  "Y2Wh/g": "Video File (*.mp4/*.mov)",
  "YLvNj+": "To Be Deployed",
  kUbrNT:
    "Please upload the file to the Media Library first.Only approved files can be used as templates.",
  n997QX: "Video Height",
  rBD8kj: "Image X-Axis",
  uCmncQ: "Video Width",
  QwmhEP: "Content History",
  "8vC+0s": "You must select a playback content",
  "jG/AFY": "After confirmation, the device will apply the new configuration and the settings cannot be changed within one day. Are you sure you want to apply it?",
  "AxZAkZ": "Digital content uploaded to this platform is automatically reviewed by Amazon Rekognition Content Moderation to minimize the risk of public exposure. If the automated review fails, you may manually approve the content; however, in such cases, the platform assumes no responsibility for any subsequent consequences.",
  "Oyd/7c": "Manually Approved",
  "wyHcKZ": "Approval Reminder",
  "32HMy/": "{nubis} Cast version",
  "IS73A4": "Start time cannot be greater than end time",
  "jCAPQ2": "{nubis} Cast mode",
  "sWmzFs": "{ora} last update time",
  "sctjLN": "{ora} last online time",
  "uoBkfP": "{ora} last update status",
  "3yichR": "Last Edited Time",
  "d+otpZ": "Published Version",
  "k30s+D": "Last Published Time",
  "9bgunT": "When disabled, you can download and install the latest version of {ora} manually, or update it manually via the device command - {ora} update.",
  "Yh8vRi": "When enabled, it will automatically download and update when a new version of {ora} is available.",
  "ZO2gEn": "{nubis} version",
  "r+yR7v": "{nubis} Cast",
  "uf58G7": "When automatic updates are disabled, differences in the {ora} version on the device may cause some functions to be unavailable.",
  "y98D3X": "Video Y-axis"
};
